import { i18n } from '@/plugins'
import { auth } from '@/services/auth'
import { ROLE_ADMIN } from '@/composables/useIsAdmin'
import { basicStorage } from '@/services/storage'
import Store from '@/store'
import { Route } from 'vue-router'

/* eslint-disable consistent-return */
export const authGuard = (to: Route, from: Route, next: any) => {
  document.title = to.name
    ? `Seikaen-core ｜ ${i18n.t('menu.' + to.name)}`
    : 'Seikaen-core'
  // If the user is authenticated, continue with the route
  const fn = async () => {
    if (to.meta?.requiresAuth === false) {
      return next()
    }
    const reloaded = await auth.reload()

    // const enabled_jobs = auth.me.value.user.enabled_jobs

    // Check user is authorized to access this job
    // if (to.meta?.job_code && !enabled_jobs?.includes(to.meta?.job_code)) {
    //   basicStorage.setCallbackReferrer(to.fullPath)
    //   return next('/')
    // }
    if (!reloaded) {
      basicStorage.setCallbackReferrer(to.fullPath)
      return next('/logout')
    }
    if (
      to.meta?.requiresAdmin &&
      auth.me.value?.user?.role_code !== ROLE_ADMIN
    ) {
      Store.commit('setLoadingIndicator', false)
      return next('/')
    }
    return next()
  }

  return fn()
}
